import { ready } from "./utils.js";
import $ from "jquery";

ready(() => {
  const header = document.getElementsByTagName("header")[0];

  function updateHeaderScrollClasses() {
    const scrollY = window.scrollY;
    if (scrollY > 150) {
      header.classList.add("small");
    } else if (scrollY < 10) {
      header.classList.remove("small");
    }
  }

  if (header) {
    document.addEventListener("scroll", updateHeaderScrollClasses); //on scroll
    //updateHeaderScrollClasses(); //after reload
  }
});

$(function () {
  function hasProblematicElementAt(xpos, ypos) {
    const elements = document.elementsFromPoint(xpos, ypos);
    for (const element of elements) {
      if (["bl-hero"].some(cls => element.classList.contains(cls)) || element.tagName === "FOOTER") {
        return true;
      }
    }
    return false;
  }

  const $erstbesuchMobile = $(".erstbesuch-mobile");
  function updateErstbesuchMobile() {
    const hide = hasProblematicElementAt(window.innerWidth * 0.5, window.innerHeight * 0.5)
      || hasProblematicElementAt(window.innerWidth * 0.5, window.innerHeight * 0.75);

    $erstbesuchMobile.toggleClass("visible", !hide);
  }

  window.setInterval(updateErstbesuchMobile, 1000);
});
